import { IconButton } from '@/components/ui/icon-button'
import { AppTooltip } from '@components'
import { useAuth } from '@state/auth';
import { LifeBuoy, LogOut, Settings } from 'lucide-solid'
import type { ParentProps } from "solid-js";
import { useService } from 'solid-services';
import { css } from 'styled-system/css'
import { Grid } from 'styled-system/jsx'

export function FocusLayout(props: ParentProps) {

  const { logout } = useService(useAuth)()

  return <Grid bg='bg.default' position='fixed' top='0' left='0' right='0' bottom='0' height='100dvh' gridTemplateRows='auto 1fr'>
    <header class={css({
      display: 'flex',
      p: 3,
      gap: 3,
      justifyContent: 'flex-end'
    })}>
      <AppTooltip content="Settings">
        <IconButton variant='subtle'>
          <Settings />
        </IconButton>
      </AppTooltip>
      <AppTooltip content="Support">
        <IconButton variant='subtle'>
          <LifeBuoy />
        </IconButton>
      </AppTooltip>
      <AppTooltip content="Log out">
        <IconButton variant='subtle' onclick={logout}>
          <LogOut />
        </IconButton>
      </AppTooltip>
    </header>
    {props.children}
  </Grid>
}
